module.exports = __webpack_public_path__ + "static/media/sync.b759ed7a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/sync.mp4
// module id = 1491
// module chunks = 39